import {
  Checkbox,
  DatePicker,
  defaultDatePickerStrings,
  DefaultButton,
  Dropdown,
  IconButton,
  PrimaryButton,
  TextField,
} from "@fluentui/react";
import React, { useContext, useEffect } from "react";
import { t } from "i18next";
import NextPreviousSection from "../NextPreviousSection.jsx/NextPreviousSection";
import "../../firm.css";
import { ACTIONS, BORDER, USERTYPES } from "../../../../constants/Constants";
import CustomCheckBox from "../HeaderFileChecks/CustomCheckBox";
// import { ACTIONS, USERTYPES } from "../../../../constants/Constants";
import { Country, State, City } from "country-state-city";
import { useState } from "react";
import DropDown from "../../../../components/SVGComponents/Tools/DropDown";
import Select from "react-select";
import { rollups } from "d3-array";
import themeContext from "../../../../context/theme/ThemeContext";
import { ChoiceGroup } from "@fluentui/react";

import CustomPhoneInput from "../../../Hospital/components/ContactDetails/CustomPhoneInput";
import { getEnv } from "../../../../helpers/EnvHelper";
import {
  CXR_TRIAGE_MAX_AGE,
  CXR_TRIAGE_MIN_AGE,
  getCxrTriageModeMinAge,
  getCxrViewerMode,
  isCxrTriageMinAgeValid,
} from "../../helpers/CxrTriageMinAge";
const textFieldStyles = {
  root: {
    borderRadius: "5px",
  },
};

const HospitalDetailsSection = (props) => {
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const { getThemeColor } = useContext(themeContext);
  const [Viewer, setViewer] = useState(props.values.cxrVersionViewer ?? false);
  const [studyList, setStudyList] = useState(
    props.values.cxrVersionStudyList ?? false,
  );
  const [showFindings, setShowFindings] = useState(
    props.values.showFindings ?? true,
  );
  const [enableSecondaryCapture, setEnableSecondaryCapture] = useState(
    props.values.enableSecondaryCapture ?? false,
  );
  //Added for  the quality-model flag
  const [enableQualityModel, setEnableQualityModel] = useState(
    props.values.enableQualityModel ?? false,
  );
  // Study download zips: off stores every DICOM as-is, on deflates uncompressed DICOM
  const [compressStudyDownload, setCompressStudyDownload] = useState(
    props.values.compressStudyDownload ?? false,
  );
  const [demoFirm, setDemoFirm] = useState(
    props.values.demoFirm ?? false,
  );
  const [demoExpiryType, setDemoExpiryType] = useState(
    props.values.demoExpiryType ?? null,
  );
  const [demoExpiryDate, setDemoExpiryDate] = useState(
    props.values.demoExpiryDate ?? null,
  );
  const [maxStudyUploads, setMaxStudyUploads] = useState(
    props.values.maxStudyUploads ?? null,
  );
  const [demoStudyCount, setDemoStudyCount] = useState(
    props.values.demoStudyCount ?? null,
  );
  const [demoError, setDemoError] = useState(null);
  const [showProbability, setShowProbability] = useState(
    props.values.showProbability,
  );
  const [cxrTriageMinAge, setCxrTriageMinAge] = useState(
    props.values.cxrTriageMinAge ?? null,
  );
  const [cxrTriageMinAgeError, setCxrTriageMinAgeError] = useState(null);
  const [subtleFindings, setSubtleFindings] = useState(
    props.values.subtleFindings,
  );
  const [showAboveThresholdScore, setShowAboveThresholdScore] = useState(
    props.values.setShowAboveThresholdScore ?? true,
  );
  const [enableGenkiStudyInference, setEnableGenkiStudyInference] = useState(
    props.values.enableGenkiStudyInference ?? true,
  );

  const handleEnableGenkiStudyInferenceChange = () => {
    setEnableGenkiStudyInference(!enableGenkiStudyInference);
    props.values.enableGenkiStudyInference =
      !props.values.enableGenkiStudyInference;
  };

  const handleSubtleFindingsChange = () => {
    setSubtleFindings(!subtleFindings);
    props.values.subtleFindings = !props.values.subtleFindings;
  };

  const handleShowAboveThresholdScoreChange = () => {
    setShowAboveThresholdScore(!showAboveThresholdScore);
    props.values.showAboveThresholdScore =
      !props.values.showAboveThresholdScore;
  };

  const handleShowFindingsChange = () => {
    setShowFindings(!showFindings);
    props.values.showFindings = !props.values.showFindings;
    applyCxrTriageModeMinAge();
  };

  const handleEnableSecondaryCapture = () => {
    setEnableSecondaryCapture(!enableSecondaryCapture);
    props.values.enableSecondaryCapture = !props.values.enableSecondaryCapture;
  };
  //Added Quality Model
const handleCompressStudyDownload = () => {
    const newValue = !compressStudyDownload;
    setCompressStudyDownload(newValue);
    props.values.compressStudyDownload = newValue;
    if (props.setFieldValue) {
        props.setFieldValue("compressStudyDownload", newValue);
    }
};
const handleEnableQualityModel = () => {
    const newValue = !enableQualityModel;
    setEnableQualityModel(newValue);
    props.values.enableQualityModel = newValue;
    if (props.setFieldValue) {
        props.setFieldValue("enableQualityModel", newValue);
        console.log("setFieldValue called with:", newValue); // ADD THIS
    } else {
        console.log("setFieldValue is NOT available as prop"); // ADD THIS
    }
};

  const validateDemoFields = (df, type, expiry, uploads) => {
    if (!df) {
      setDemoError(null);
      return;
    }
    if (!type) {
      setDemoError("Select an expiry criteria type");
      return;
    }
    if (type === "date") {
      if (!(expiry instanceof Date && !isNaN(expiry))) {
        setDemoError("Select Expiry date");
        return;
      }
    } else if (type === "uploads") {
      if (uploads == null) {
        setDemoError("Select Max study Upload");
        return;
      }
      if (isNaN(uploads)) {
        setDemoError("Enter a valid value");
        return;
      }
      if (uploads <= 0) {
        setDemoError(t("hospital.max-study-uploads-positive") || "0 and negative values are not allowed");
        return;
      }
      if (uploads > 99999) {
        setDemoError(t("hospital.max-study-uploads-max-digits") || "Cannot exceed 5 digits");
        return;
      }
    }
    setDemoError(null);
  };

  const handleDemoFirm = () => {
    const newValue = !demoFirm;
    setDemoFirm(newValue);
    props.values.demoFirm = newValue;
    if (props.setFieldValue) {
      props.setFieldValue("demoFirm", newValue);
    }
    if (!newValue) {
      setDemoExpiryType(null);
      setDemoExpiryDate(null);
      setMaxStudyUploads(null);
      setDemoError(null);
      props.values.demoExpiryType = null;
      props.values.demoExpiryDate = null;
      props.values.maxStudyUploads = null;
      if (props.setFieldValue) {
        props.setFieldValue("demoExpiryType", null);
        props.setFieldValue("demoExpiryDate", null);
        props.setFieldValue("maxStudyUploads", null);
      }
    } else {
      validateDemoFields(true, demoExpiryType, demoExpiryDate, maxStudyUploads);
    }
  };

  const handleDemoExpiryDate = (date) => {
    setDemoExpiryDate(date);
    props.values.demoExpiryDate = date;
    if (props.setFieldValue) {
      props.setFieldValue("demoExpiryDate", date);
    }
    validateDemoFields(demoFirm, demoExpiryType, date, maxStudyUploads);
  };

  const handleMaxStudyUploads = (e, newValue) => {
    if (newValue != null && newValue !== "" && newValue.length > 5) return;
    const val = (newValue === "" || newValue == null) ? null : parseInt(newValue, 10);
    setMaxStudyUploads(val);
    props.values.maxStudyUploads = val;
    if (props.setFieldValue) {
      props.setFieldValue("maxStudyUploads", val);
    }
    validateDemoFields(demoFirm, demoExpiryType, demoExpiryDate, val);
  };

  const handleDemoExpiryType = (e, option) => {
    const newType = option.key;
    let effectiveDate = demoExpiryDate;
    let effectiveUploads = maxStudyUploads;
    if (newType === "date") {
      effectiveUploads = null;
      setMaxStudyUploads(null);
      props.values.maxStudyUploads = null;
      if (props.setFieldValue) {
        props.setFieldValue("maxStudyUploads", null);
      }
    } else {
      effectiveDate = null;
      setDemoExpiryDate(null);
      props.values.demoExpiryDate = null;
      if (props.setFieldValue) {
        props.setFieldValue("demoExpiryDate", null);
      }
    }
    setDemoExpiryType(newType);
    props.values.demoExpiryType = newType;
    if (props.setFieldValue) {
      props.setFieldValue("demoExpiryType", newType);
    }
    validateDemoFields(demoFirm, newType, effectiveDate, effectiveUploads);
  };

  const handleShowProbabilityChange = () => {
    setShowProbability(!showProbability);
    props.values.showProbability = !props.values.showProbability;
    applyCxrTriageModeMinAge();
  };

  const handleViewerChange = (value) => {
    if (!value && !Viewer) return;
    setViewer(value);
    props.values.cxrVersionViewer = value;
    applyCxrTriageModeMinAge();
  };

  const isParentFirm = props.values.isMinimalAccount != 1;
  const cxrViewerMode = getCxrViewerMode(props.values);
  const cxrTriageModeMinAge = CXR_TRIAGE_MIN_AGE[cxrViewerMode];

  const updateCxrTriageMinAge = (value) => {
    setCxrTriageMinAge(value);
    props.values.cxrTriageMinAge = value;
    if (props.setFieldValue) {
      props.setFieldValue("cxrTriageMinAge", value);
    }
    setCxrTriageMinAgeError(
      isCxrTriageMinAgeValid(props.values)
        ? null
        : t("hospital.cxr-triage-min-age-range", {
            min: getCxrTriageModeMinAge(props.values),
            max: CXR_TRIAGE_MAX_AGE,
          }),
    );
  };

  const handleCxrTriageMinAgeChange = (e, newValue) => {
    if (newValue !== "" && !/^\d{1,3}$/.test(newValue)) return;
    updateCxrTriageMinAge(newValue === "" ? null : parseInt(newValue, 10));
  };

  const handleCxrTriageMinAgeBlur = () => {
    if (props.values.cxrTriageMinAge == null) {
      updateCxrTriageMinAge(getCxrTriageModeMinAge(props.values));
    }
  };

  const applyCxrTriageModeMinAge = () => {
    if (!isParentFirm) return;
    const modeMinAge = getCxrTriageModeMinAge(props.values);
    const current = props.values.cxrTriageMinAge;
    updateCxrTriageMinAge(current == null || current < modeMinAge ? modeMinAge : current);
  };

  const renderCxrTriageMinAgeField = () => (
    <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
      <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
        <p className="single-line-form-field-key">
          {t("hospital.cxr-triage-min-age")}
        </p>
      </div>
      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
        <div style={{ marginTop: "5px", maxWidth: 420 }}>
          <TextField
            type="number"
            min={cxrTriageModeMinAge}
            max={CXR_TRIAGE_MAX_AGE}
            step={1}
            value={cxrTriageMinAge != null ? String(cxrTriageMinAge) : ""}
            placeholder={String(cxrTriageModeMinAge)}
            onChange={handleCxrTriageMinAgeChange}
            onBlur={handleCxrTriageMinAgeBlur}
            description={t("hospital.cxr-triage-min-age-helper", {
              mode: t(`hospital.cxr-viewer-mode-${cxrViewerMode}`),
              min: cxrTriageModeMinAge,
            })}
            errorMessage={cxrTriageMinAgeError ?? undefined}
            styles={{ fieldGroup: { width: 120 } }}
          />
        </div>
      </div>
    </div>
  );

  const handleStudyListChange = (value) => {
    if (!value && !studyList) return;
    setStudyList(value);
    props.values.cxrVersionStudyList = value;
  };

  const debugValues = {
    Viewer: {
      state: Viewer,
      props: props.values.cxrVersionViewer,
    },
    studyList: {
      state: studyList,
      props: props.values.cxrVersionStudyList,
    },
  };
  useEffect(() => {
    setViewer(props.values.cxrVersionViewer ?? false);
    setStudyList(props.values.cxrVersionStudyList ?? false);
  }, []);

  useEffect(() => {
    setEnableQualityModel(props.values.enableQualityModel ?? false);
  }, [props.values.enableQualityModel]);

  useEffect(() => {
    setCompressStudyDownload(props.values.compressStudyDownload ?? false);
  }, [props.values.compressStudyDownload]);

  useEffect(() => {
    setCxrTriageMinAge(props.values.cxrTriageMinAge ?? null);
  }, [props.values.cxrTriageMinAge]);

  useEffect(() => {
    setDemoFirm(props.values.demoFirm ?? false);
  }, [props.values.demoFirm]);

  useEffect(() => {
    setDemoExpiryType(props.values.demoExpiryType ?? null);
  }, [props.values.demoExpiryType]);

  useEffect(() => {
    const val = props.values.demoExpiryDate ?? null;
    setDemoExpiryDate(val);
  }, [props.values.demoExpiryDate]);

  useEffect(() => {
    const val = props.values.maxStudyUploads ?? null;
    setMaxStudyUploads(val);
  }, [props.values.maxStudyUploads]);

  useEffect(() => {
    const val = props.values.demoStudyCount ?? null;
    setDemoStudyCount(val);
  }, [props.values.demoStudyCount]);

  useEffect(() => {
    if (!props.values.demoFirm) {
      setDemoError(null);
    }
  }, [props.values.demoFirm, props.values.demoExpiryType, props.values.demoExpiryDate, props.values.maxStudyUploads]);


  useEffect(() => {
    if (!Viewer && !studyList) {
      props.values.boneEnabled = false;
    }
  }, [Viewer, studyList]);

  useEffect(() => {
    console.log("Values Updated:", {
      Viewer: {
        state: Viewer,
        props: props.values.cxrVersionViewer,
      },
      studyList: {
        state: studyList,
        props: props.values.cxrVersionStudyList,
      },
      timestamp: new Date().toISOString(),
    });
  }, [
    Viewer,
    studyList,
    props.values.cxrVersionViewer,
    props.values.cxrVersionStudyList,
  ]);

  let countryOptions = Country.getAllCountries().map((country) => {
    return {
      value: country.isoCode,
      label: country.name,
    };
  });

  const handleCountryChange = (item) => {
    props.setSelectedCountry(item);
    props.values.country = item.label;
    props.setSelectedState("");
    props.setSelectedCity("");
    props.values.state = "";
    props.values.city = "";
  };

  useEffect(() => {
    setStateOptions(
      State.getStatesOfCountry(props.selectedCountry.value).map((state) => {
        return {
          value: state.isoCode,
          label: state.name,
        };
      }),
    );
  }, [props.selectedCountry]);

  const handleStateChange = (item) => {
    props.setSelectedState(item);
    props.values.state = item.label;
    props.setSelectedCity("");
    props.values.city = "";
  };

  useEffect(() => {
    setCityOptions(
      City.getCitiesOfState(
        props.selectedCountry.value,
        props.selectedState.value,
      ).map((city) => {
        return {
          value: city.name,
          label: city.name,
        };
      }),
    );
  }, [props.selectedState]);

  const handleCityChange = (item) => {
    props.setSelectedCity(item);
    props.values.city = item.label;
  };

  let enterprise =
    getEnv("REACT_APP_ENTERPRISE_PLATFORM") == "true" ||
    getEnv("REACT_APP_ENTERPRISE_PLATFORM") == true
      ? true
      : false;

  if (props.firmMode === "projects") {
    return (
      <>
        {(props.action === ACTIONS.ADD ||
          (props.action === ACTIONS.EDIT &&
          (props.roles[0] === USERTYPES.FIRMADMIN || props.roles[0] === USERTYPES.ADMIN || !props.ownFirm))) && (
          <>
            <div className="tab-section">
              <section className="sectionA" style={{ marginBottom: "1rem" }}>
                <p
                  style={{
                    fontSize: "22px",
                    fontWeight: "600",
                    padding: "0px 0px",
                  }}
                >
                  Project Details
                </p>
              </section>

              <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                  <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                    <div className="form-heading">{t("hospital.name")}</div>
                    <TextField
                      name="name"
                      placeholder="Project Name"
                      resizable={false}
                      value={props.values.name}
                      onBlur={props.handleBlur}
                      onChange={(e) => {
                        props.handleChange(e);
                        if (
                          props.errorState.name.error != undefined ||
                          props.errorState.name.error != null
                        ) {
                          props.errorState.name.error = false;
                        }
                      }}
                      errorMessage={
                        props.errorState?.name?.error &&
                        props.errorState?.name?.msg
                      }
                    />
                  </div>
                </div>

                <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                  <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                    <div className="form-heading">{t("hospital.address")}</div>
                    <TextField
                      name="address"
                      placeholder={t("hospital.address")}
                      multiline
                      value={props.values.address}
                      onBlur={props.handleBlur}
                      onChange={(e) => {
                        props.handleChange(e);
                        if (
                          props.errorState.address.error != undefined ||
                          props.errorState.address.error != null
                        ) {
                          props.errorState.address.error = false;
                        }
                      }}
                      errorMessage={
                        props.errorState?.address?.error &&
                        props.errorState?.address?.msg
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {props.action === ACTIONS.VIEW &&
        (props.roles[0] === USERTYPES.FIRMADMIN || props.roles[0] === USERTYPES.ADMIN || !props.ownFirm) && (
            <>
              <div className="tab-section">
                <section className="sectionA" style={{ marginBottom: "1rem" }}>
                  <p
                    style={{
                      fontSize: "22px",
                      fontWeight: "600",
                      padding: "0px 0px",
                    }}
                  >
                    Project Details
                  </p>
                </section>
                <div className="ms-Grid" dir="ltr">
                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                      <div className="form-heading">{t("hospital.name")}</div>
                      <div className="form-mt-10">{props.values.name}</div>
                    </div>
                    {props.roles[0] != USERTYPES.SUPERVISOR && (
                      <>
                        <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                          <div className="form-heading">Description</div>
                          <div className="form-mt-10">
                            {props.values.address}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
      </>
    );
  }

  return (
    <>
      {(props.action === ACTIONS.ADD ||
        (props.action === ACTIONS.EDIT &&
          (props.roles[0] === USERTYPES.FIRMADMIN || !props.ownFirm))) && (
        <div className="tab-section">
          <section className="sectionA" style={{ marginBottom: "1rem" }}>
            <p
              style={{
                fontSize: "22px",
                fontWeight: "600",
                padding: "0px 0px",
              }}
            >
              {enterprise
                ? t("hospital.hospital-details")
                : props.firmType === 1
                  ? t("hospital.provider-details")
                  : props.ownFirm || props.roles[0] === USERTYPES.ADMIN
                    ? t("hospital.firm-details")
                    : t("hospital.client-details")}
            </p>
          </section>
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                <div className="form-heading">{t("hospital.name")}</div>
                <TextField
                  name="name"
                  placeholder={t("hospital.firm-name")}
                  resizable={false}
                  value={props.values.name}
                  onBlur={props.handleBlur}
                  onChange={(e) => {
                    props.handleChange(e);
                    if (
                      props.errorState.name.error != undefined ||
                      props.errorState.name.error != null
                    ) {
                      props.errorState.name.error = false;
                    }
                  }}
                  errorMessage={
                    props.errorState?.name?.error && props.errorState?.name?.msg
                  }
                />
              </div>
            </div>

            <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                <div className="form-heading">{t("hospital.address")}</div>
                <TextField
                  name="address"
                  placeholder={t("hospital.address")}
                  multiline
                  value={props.values.address}
                  onBlur={props.handleBlur}
                  onChange={(e) => {
                    props.handleChange(e);
                    if (
                      props.errorState.address.error != undefined ||
                      props.errorState.address.error != null
                    ) {
                      props.errorState.address.error = false;
                    }
                  }}
                  errorMessage={
                    props.errorState?.address?.error &&
                    props.errorState?.address?.msg
                  }
                />
              </div>
            </div>

            <div
              className="ms-Grid-row"
              style={{
                marginTop: "20px",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12">
                <div className="form-heading">{t("hospital.country")}</div>
                <Select
                  classNamePrefix="react-select"
                  options={countryOptions}
                  defaultValue={props.selectedCountry}
                  value={props.selectedCountry}
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      width: "100% !important",
                      // background: "#161616 !important",
                      color: getThemeColor("primary-color"),
                      backgroundColor: getThemeColor(
                        "action-details-background",
                      ),
                      border: props.errorState?.country?.error
                        ? "1px solid rgb(164, 38, 44) !important"
                        : BORDER.TAB,
                    }),
                    menu: (baseStyles, state) => ({
                      ...baseStyles,
                      width: "100% !important",
                      backgroundColor: state.isFocused
                        ? getThemeColor("popup-hover")
                        : getThemeColor("action-details-background"),
                      "&:hover": {
                        backgroundColor: `${getThemeColor(
                          "popup-hover",
                        )} !important`,
                      },
                    }),
                    menuList: (baseStyles, state) => ({
                      ...baseStyles,
                      backgroundColor: state.isFocused
                        ? getThemeColor("popup-hover")
                        : getThemeColor("action-details-background"),
                      "&:hover": {
                        backgroundColor: `${getThemeColor(
                          "popup-hover",
                        )} !important`,
                      },
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontSize: "14px",
                      lineHeight: "18px",
                      color: getThemeColor("primary-color"),
                      backgroundColor: state.isFocused
                        ? getThemeColor("popup-hover")
                        : getThemeColor("action-details-background"),
                      "&:hover": {
                        backgroundColor: `${getThemeColor(
                          "popup-hover",
                        )} !important`,
                      },
                    }),
                  }}
                  onChange={(item) => {
                    handleCountryChange(item);
                  }}
                />
                {props.errorState?.country?.error && (
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "400",
                      color: "red",
                    }}
                  >
                    {props.errorState?.country?.msg}
                  </span>
                )}
              </div>
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12">
                <div className="form-heading">{t("hospital.state")}</div>
                <Select
                  classNamePrefix="react-select"
                  options={stateOptions}
                  defaultValue={props.selectedState}
                  value={props.selectedState}
                  placeholder="Select State"
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      width: "100% !important",
                      // background: "#161616 !important",
                      color: getThemeColor("primary-color"),
                      backgroundColor: getThemeColor(
                        "action-details-background",
                      ),
                      border: props.errorState?.state?.error
                        ? "1px solid rgb(164, 38, 44) !important"
                        : BORDER.TAB,
                    }),
                    menu: (baseStyles, state) => ({
                      ...baseStyles,
                      width: "100% !important",
                      backgroundColor: state.isFocused
                        ? getThemeColor("popup-hover")
                        : getThemeColor("action-details-background"),
                      "&:hover": {
                        backgroundColor: `${getThemeColor(
                          "popup-hover",
                        )} !important`,
                      },
                    }),
                    menuList: (baseStyles, state) => ({
                      ...baseStyles,
                      backgroundColor: state.isFocused
                        ? getThemeColor("popup-hover")
                        : getThemeColor("action-details-background"),
                      "&:hover": {
                        backgroundColor: `${getThemeColor(
                          "popup-hover",
                        )} !important`,
                      },
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontSize: "14px",
                      lineHeight: "18px",
                      color: getThemeColor("primary-color"),
                      backgroundColor: state.isFocused
                        ? getThemeColor("popup-hover")
                        : getThemeColor("action-details-background"),
                      "&:hover": {
                        backgroundColor: `${getThemeColor(
                          "popup-hover",
                        )} !important`,
                      },
                    }),
                  }}
                  onChange={(item) => {
                    handleStateChange(item);
                  }}
                />
                {props.errorState?.state?.error && (
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "400",
                      color: "red",
                    }}
                  >
                    {props.errorState?.state?.msg}
                  </span>
                )}
              </div>
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12">
                <div className="form-heading">{t("hospital.city")}</div>
                <Select
                  classNamePrefix="react-select"
                  options={cityOptions}
                  defaultValue={props.selectedCity}
                  value={props.selectedCity}
                  placeholder="Select City"
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      width: "100% !important",
                      // background: "#161616 !important",
                      color: getThemeColor("primary-color"),
                      backgroundColor: getThemeColor(
                        "action-details-background",
                      ),
                      border: props.errorState?.city?.error
                        ? "1px solid rgb(164, 38, 44) !important"
                        : BORDER.TAB,
                    }),
                    menu: (baseStyles, state) => ({
                      ...baseStyles,
                      width: "100% !important",
                      backgroundColor: state.isFocused
                        ? getThemeColor("popup-hover")
                        : getThemeColor("action-details-background"),
                      "&:hover": {
                        backgroundColor: `${getThemeColor(
                          "popup-hover",
                        )} !important`,
                      },
                    }),
                    menuList: (baseStyles, state) => ({
                      ...baseStyles,
                      backgroundColor: state.isFocused
                        ? getThemeColor("popup-hover")
                        : getThemeColor("action-details-background"),
                      "&:hover": {
                        backgroundColor: `${getThemeColor(
                          "popup-hover",
                        )} !important`,
                      },
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontSize: "14px",
                      lineHeight: "18px",
                      color: getThemeColor("primary-color"),
                      backgroundColor: state.isFocused
                        ? getThemeColor("popup-hover")
                        : getThemeColor("action-details-background"),
                      "&:hover": {
                        backgroundColor: `${getThemeColor(
                          "popup-hover",
                        )} !important`,
                      },
                    }),
                  }}
                  onChange={(item) => {
                    handleCityChange(item);
                  }}
                />
                {props.errorState?.city?.error && (
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "400",
                      color: "red",
                    }}
                  >
                    {props.errorState?.city?.msg}
                  </span>
                )}
              </div>
            </div>
            {(props.roles[0] === USERTYPES.ADMIN ||
              (props.roles[0] === USERTYPES.FIRMADMIN &&
                props.action === ACTIONS.EDIT)) &&
              props.values.isMinimalAccount != 1 && (
                <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                  <div className="form-field ms-Grid-col ms-sm12 ms-md ms-lg4 ms-xl4">
                    <div className="form-heading">
                      {t("hospital.customer-support-number")}
                    </div>
                    <CustomPhoneInput
                      name={"customerSupportNumber"}
                      value={props.values?.customerSupportNumber}
                      errorState={
                        props.errorState?.customerSupportNumber?.error
                      }
                      errorMessage={
                        props.errorState?.customerSupportNumber?.msg
                      }
                      checkError={props.checkError}
                      onChangeCustom={(value, data) => {
                        if (!value.startsWith("+")) {
                          value = "+" + value;
                        }
                        props.values.customerSupportNumber = value;
                        props.values.customerSupportNumberCountryCode =
                          data.countryCode;
                        props.values.customerSupportNumberDialCode =
                          data.dialCode;

                        if (
                          props.errorState.customerSupportNumber.error !=
                            undefined ||
                          props.errorState.customerSupportNumber.error != null
                        ) {
                          props.errorState.customerSupportNumber.error = false;
                        }
                      }}
                    />
                  </div>
                </div>
              )}

            {/* (removed): "Max Priority Count" was duplicated here on the Client Details
                tab. It already exists on the Configure Settings tab (ConfigureSettings.jsx),
                so it is removed from Client Details to avoid showing the same field twice.
            {props.roles[0] === USERTYPES.FIRMADMIN &&
              (props.action === ACTIONS.ADD ||
                (props.action === ACTIONS.EDIT && !props.ownFirm)) && (
                <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                  <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                    <div className="form-heading">
                      {t("hospital.max-priority-count")}
                    </div>
                    <TextField
                      name="priorityCount"
                      type="number"
                      resizable={false}
                      value={props.values.priorityCount}
                      onBlur={props.handleBlur}
                      onChange={(e) => {
                        props.handleChange(e);
                        if (
                          props.errorState.priorityCount.error != undefined ||
                          props.errorState.priorityCount.error != null
                        ) {
                          props.errorState.priorityCount.error = false;
                        }
                      }}
                      errorMessage={
                        props.errorState?.priorityCount?.error &&
                        props.errorState?.priorityCount?.msg
                      }
                    />
                  </div>
                </div>
              )}
            */}

            <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                <p className="single-line-form-field-key">
                  {t("hospital.triage-xray")}
                </p>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                <div style={{ marginTop: "5px" }}>
                  <CustomCheckBox
                    parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                    values={props.values.triageXRAYStudies}
                    onChangeCustom={() => {
                      props.values.triageXRAYStudies =
                        !props.values.triageXRAYStudies;
                    }}
                  />
                </div>
              </div>
            </div>
            {props.roles[0] === USERTYPES.ADMIN &&
              props.action === ACTIONS.ADD && (
                <>
                  <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                    <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.study-list-mode")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div
                        style={{ marginTop: "5px" }}
                        className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      >
                        <ChoiceGroup
                          options={[
                            { key: "detect", text: t("hospital.detect") },
                            { key: "analyze", text: t("hospital.analyze") },
                          ]}
                          selectedKey={studyList ? "analyze" : "detect"}
                          onChange={(ev, option) =>
                            handleStudyListChange(option.key === "analyze")
                          }
                          styles={{
                            flexContainer: { display: "flex", gap: "20px" },
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                    <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.viewer-mode")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div
                        style={{ marginTop: "5px" }}
                        className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      >
                        <ChoiceGroup
                          options={[
                            { key: "detect", text: t("hospital.detect") },
                            { key: "analyze", text: t("hospital.analyze") },
                          ]}
                          selectedKey={Viewer ? "analyze" : "detect"}
                          onChange={(ev, option) =>
                            handleViewerChange(option.key === "analyze")
                          }
                          styles={{
                            flexContainer: { display: "flex", gap: "20px" },
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {(Viewer == 1 || studyList == 1) && (
                    <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                      <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                        <p className="single-line-form-field-key">
                          {t("hospital.bone-enabled")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div style={{ marginTop: "5px" }}>
                          <CustomCheckBox
                            parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                            values={props.values.boneEnabled}
                            onChangeCustom={() => {
                              props.values.boneEnabled =
                                !props.values.boneEnabled;
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  {props.values.cxrVersionViewer && (
                    <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                      <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                        <p className="single-line-form-field-key">
                          {t("hospital.showFindings")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div style={{ marginTop: "5px" }}>
                          <CustomCheckBox
                            parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                            values={props.values.showFindings}
                            onChangeCustom={handleShowFindingsChange}
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                    <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.showProbability")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.showProbability}
                          onChangeCustom={handleShowProbabilityChange}
                        />
                      </div>
                    </div>
                  </div>
                  {isParentFirm && renderCxrTriageMinAgeField()}

                  <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                    <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.subtleFindings")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.subtleFindings}
                          onChangeCustom={handleSubtleFindingsChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                    <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.showAboveThresholdScore")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.showAboveThresholdScore}
                          onChangeCustom={handleShowAboveThresholdScoreChange}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
            {(props.roles[0] === USERTYPES.ADMIN ||
              props.roles[0] === USERTYPES.FIRMADMIN) &&
              props.action === ACTIONS.ADD && (
                <>
                  <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                    <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.enableGenkiStudyInference")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.enableGenkiStudyInference}
                          onChangeCustom={handleEnableGenkiStudyInferenceChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                    <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.enable-secondary-capture")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.enableSecondaryCapture}
                          onChangeCustom={handleEnableSecondaryCapture}
                        />
                      </div>
                    </div>
                  </div>
                  {/* Added Quality Model */}
                  <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                    <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.enable-quality-model")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.enableQualityModel}
                          onChangeCustom={handleEnableQualityModel}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                    <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.compress-study-download")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.compressStudyDownload}
                          onChangeCustom={handleCompressStudyDownload}
                        />
                      </div>
                    </div>
                  </div>
                  {(props.roles[0] === USERTYPES.FIRMADMIN || props.roles[0] === USERTYPES.ADMIN) && (
                    <fieldset className="border rounded p-4 fieldset-bucket-config" style={{ width: 460 }}>
                      <legend className="font-bold">Demo Configuration</legend>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          isChecked={demoFirm}
                          onChangeCustom={handleDemoFirm}
                          label={t("hospital.demo-firm")}
                        />
                      </div>
                       {demoFirm && (
                         <>
                         <div style={{ marginBottom: 8, fontSize: "13px", color: "#333" }}>
                      {demoExpiryType === "date"
                        ? "Demo expiry date"
                        : demoExpiryType === "uploads"
                        ? "Max Study upload limit"
                        : "None selected"}
                    </div>
                           <div style={{ display: "flex", alignItems: "center", marginTop: 8 }}>
                             <Dropdown
                               placeholder="Select expiry criteria"
                               options={[
                                 { key: "date", text: "Demo expiry date" },
                                 { key: "uploads", text: "Max Study upload limit" },
                               ]}
                               selectedKey={demoExpiryType}
                               onChange={handleDemoExpiryType}
                               style={{ width: 200, marginRight: 8 }}
                             />
                              {demoExpiryType === "date" && (
                                <>
                                <div style={{width : 200}}>
                             <DatePicker 
                                      value={demoExpiryDate}
                                      onSelectDate={handleDemoExpiryDate}
                                      strings={defaultDatePickerStrings}
                                      isRequired={false}
                                      placeholder="Select date"
                                      minDate={new Date(new Date().setDate(new Date().getDate()+1))}
                                      formatDate={(date) => {
                                        if (!date) return "";
                                        const day = String(date.getDate()).padStart(2, '0');
                                        const month = date.toLocaleString('en', { month: 'short' }).toLowerCase();
                                        const year = date.getFullYear();
                                        return `${day}-${month}-${year}`;
                                      }}
                                      calendarProps={{
                                        calendarDayProps: {
                                          styles: {
                                            dayIsToday: {
                                              backgroundColor: "transparent !important",
                                              borderRadius: "0 !important",
                                              color: "inherit !important",
                                              fontWeight: "normal !important",
                                            },
                                          },
                                        },
                                      }}
                                    />
                                    </div>
                                  {demoExpiryDate && (
                                    <IconButton
                                      iconProps={{ iconName: "Cancel" }}
                                      onClick={() => handleDemoExpiryDate(null)}
                                      title="Clear date"
                                      ariaLabel="Clear date"
                                    />
                                  )}
                                </>
                              )}
                              {demoExpiryType === "uploads" && (
                                <TextField
                                  type="number"
                                  min={1}
                                  value={maxStudyUploads != null ? String(maxStudyUploads) : ""}
                                  onChange={handleMaxStudyUploads}
                                  placeholder="Maximum uploads"
                                  style={{ width: 200 }}
                                />
                              )}
                             </div>
                             {demoExpiryType === "uploads" && demoStudyCount != null && maxStudyUploads != null && maxStudyUploads > 0 && (
                               <div style={{ marginTop: 8, fontSize: "12px", color: "#666" }}>
                                Studies Consumed: {demoStudyCount} / {maxStudyUploads}
                               </div>
                             )}
                             {demoError && (
                               <div style={{ marginTop: 8 }}>
                                 <span style={{ fontSize: "12px", fontWeight: "700", color: "#ff0000" }}>
                                   {demoError}
                                 </span>
                               </div>
                             )}
                           </>
                         )}
                      <p style={{ fontSize: "12px", color: "#666" }}>
                        *Demo Status will deactivate automatically once the selected expiry criteria is reached.
                      </p>
                    </fieldset>
                  )}
                </>
              )}

            {props.action === ACTIONS.EDIT && (
              <>
                <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                    <div className="form-heading">{t("hospital.status")}</div>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.active ? 1 : 0}
                      onChangeCustom={() => {
                        props.values.active = !props.values.active;
                      }}
                    />
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                    <div className="form-heading">{t("hospital.type")}</div>
                    <div className="form-mt-10">{props.values.firmType}</div>
                  </div>
                </div>
                <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12">
                    <div className="form-heading">{t("hospital.code")}</div>
                    <div className="form-mt-10">{props.values.code}</div>
                  </div>
                </div>
              </>
            )}
            {props.action === ACTIONS.EDIT &&
              props.roles[0] === USERTYPES.ADMIN && (
                <fieldset className="border rounded p-4 fieldset-bucket-config" style={{ width: 460, marginTop: "20px" }}>
                  <legend className="font-bold">Demo Configuration</legend>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      isChecked={demoFirm}
                      onChangeCustom={handleDemoFirm}
                      label={t("hospital.demo-firm")}
                    />
                  </div>
                  {demoFirm && (
                    <>
                      <div style={{ marginBottom: 8, fontSize: "13px", color: "#333" }}>
                        {demoExpiryType === "date"
                          ? "Demo expiry date"
                          : demoExpiryType === "uploads"
                          ? "Max Study upload limit"
                          : "None selected"}
                      </div>
                      <div style={{ display: "flex", alignItems: "center", marginTop: 8 }}>
                        <Dropdown
                          placeholder="Select expiry criteria"
                          options={[
                            { key: "date", text: "Demo expiry date" },
                            { key: "uploads", text: "Max Study upload limit" },
                          ]}
                          selectedKey={demoExpiryType}
                          onChange={handleDemoExpiryType}
                          style={{ width: 200, marginRight: 8 }}
                        />
                        {demoExpiryType === "date" && (
                          <>
                            <div style={{ width: 200 }}>
                              <DatePicker
                                value={demoExpiryDate}
                                onSelectDate={handleDemoExpiryDate}
                                strings={defaultDatePickerStrings}
                                isRequired={false}
                                placeholder="Select date"
                                minDate={new Date(new Date().setDate(new Date().getDate()+1))}
                                formatDate={(date) => {
                                  if (!date) return "";
                                  const day = String(date.getDate()).padStart(2, '0');
                                  const month = date.toLocaleString('en', { month: 'short' }).toLowerCase();
                                  const year = date.getFullYear();
                                  return `${day}-${month}-${year}`;
                                }}
                                calendarProps={{
                                        calendarDayProps: {
                                          styles: {
                                            dayIsToday: {
                                              backgroundColor: "transparent !important",
                                              borderRadius: "0 !important",
                                              color: "inherit !important",
                                              fontWeight: "normal !important",
                                            },
                                          },
                                        },
                                      }}
                              />
                            </div>
                            {demoExpiryDate && (
                              <IconButton
                                iconProps={{ iconName: "Cancel" }}
                                onClick={() => handleDemoExpiryDate(null)}
                                title="Clear date"
                                ariaLabel="Clear date"
                              />
                            )}
                          </>
                        )}
                        {demoExpiryType === "uploads" && (
                          <TextField
                            type="number"
                            min={1}
                            value={maxStudyUploads != null ? String(maxStudyUploads) : ""}
                            onChange={handleMaxStudyUploads}
                            placeholder="Maximum uploads"
                            style={{ width: 200 }}
                          />
                        )}
                      </div>
                      {demoExpiryType === "uploads" && demoStudyCount != null && maxStudyUploads != null && maxStudyUploads > 0 && (
                        <div style={{ marginTop: 8, fontSize: "12px", color: "#666" }}>
                          Studies Consumed: {demoStudyCount} / {maxStudyUploads}
                        </div>
                      )}
                      {demoError && (
                        <div style={{ marginTop: 8 }}>
                          <span style={{ fontSize: "12px", fontWeight: "700", color: "#ff0000" }}>
                            {demoError}
                          </span>
                        </div>
                      )}
                    </>
                  )}
                  <p style={{ fontSize: "12px", color: "#666" }}>
                    *Demo Status will deactivate automatically once the selected expiry criteria is reached.
                  </p>
                </fieldset>
              )}
            {props.action === ACTIONS.EDIT &&
              props.roles[0] !== USERTYPES.ADMIN &&
              props.roles[0] === USERTYPES.FIRMADMIN &&
              props.ownFirm && (
                <>
                  {props.values.cxrVersionViewer && (
                    <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                      <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                        <p className="single-line-form-field-key">
                          {t("hospital.showFindings")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div style={{ marginTop: "5px" }}>
                          <CustomCheckBox
                            parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                            values={props.values.showFindings}
                            onChangeCustom={handleShowFindingsChange}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                    <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.showProbability")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.showProbability}
                          onChangeCustom={handleShowProbabilityChange}
                        />
                      </div>
                    </div>
                  </div>
                  {isParentFirm && renderCxrTriageMinAgeField()}

                  <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                    <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.showAboveThresholdScore")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.showAboveThresholdScore}
                          onChangeCustom={handleShowAboveThresholdScoreChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                    <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.enableGenkiStudyInference")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.enableGenkiStudyInference}
                          onChangeCustom={handleEnableGenkiStudyInferenceChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                    <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.enable-secondary-capture")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.enableSecondaryCapture}
                          onChangeCustom={handleEnableSecondaryCapture}
                        />
                      </div>
                    </div>
                  </div>
                  {/* Added Quality Model */}
                  <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                    <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.enable-quality-model")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.enableQualityModel}
                          onChangeCustom={handleEnableQualityModel}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                    <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.compress-study-download")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.compressStudyDownload}
                          onChangeCustom={handleCompressStudyDownload}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}

            {props.action === ACTIONS.EDIT &&
              props.roles[0] !== USERTYPES.ADMIN &&
              props.roles[0] === USERTYPES.FIRMADMIN &&
              !props.ownFirm && (
                <>
                  <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                    <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.enableGenkiStudyInference")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.enableGenkiStudyInference}
                          onChangeCustom={handleEnableGenkiStudyInferenceChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                    <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.enable-secondary-capture")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.enableSecondaryCapture}
                          onChangeCustom={handleEnableSecondaryCapture}
                        />
                      </div>
                    </div>
                  </div>
                  {/* Added Quality flag model */}
                  <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                    <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.enable-quality-model")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.enableQualityModel}
                          onChangeCustom={handleEnableQualityModel}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                    <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.compress-study-download")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.compressStudyDownload}
                          onChangeCustom={handleCompressStudyDownload}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}

            {props.roles[0] === USERTYPES.ADMIN &&
              props.action === ACTIONS.EDIT &&
              isParentFirm &&
              renderCxrTriageMinAgeField()}

            {props.roles[0] === USERTYPES.ADMIN &&
              (props.action === ACTIONS.ADD || props.action === ACTIONS.EDIT) && (
                <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                  <div className="ms-Grid-col ms-sm6 ms-lg3 ms-xl3">
                    <p className="single-line-form-field-key">
                      {t("hospital.mark-as-external-firm")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div style={{ marginTop: "5px" }}>
                      <CustomCheckBox
                        parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                        values={!!props.values.externalFirm}
                        onChangeCustom={() => {
                          props.values.externalFirm = !props.values.externalFirm;
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
            {(props.roles[0] === USERTYPES.FIRMADMIN && !props.ownFirm) &&
              (props.action === ACTIONS.EDIT) && (
                <fieldset className="border rounded p-4 fieldset-bucket-config" style={{ width: 460 }}>
                  <legend className="font-bold">Demo Configuration</legend>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      isChecked={demoFirm}
                      onChangeCustom={handleDemoFirm}
                      label={t("hospital.demo-firm")}
                    />
                  </div>
                  {demoFirm && (
                    <>
                    <div style={{ marginBottom: 8, fontSize: "13px", color: "#333" }}>
                      {demoExpiryType === "date"
                        ? "Demo expiry date"
                        : demoExpiryType === "uploads"
                        ? "Max Study upload limit"
                        : "None selected"}
                    </div>
                      <div style={{ display: "flex", alignItems: "center", marginTop: 8 }}>
                        <Dropdown
                          placeholder="Select expiry criteria"
                          options={[
                            { key: "date", text: "Demo expiry date" },
                            { key: "uploads", text: "Max Study upload limit" },
                          ]}
                          selectedKey={demoExpiryType}
                          onChange={handleDemoExpiryType}
                          style={{ width: 200, marginRight: 8 }}
                        />
                        {demoExpiryType === "date" && (
                          <>
                          <div style={{width: 200}}>
                            <DatePicker
                                  value={demoExpiryDate}
                                  onSelectDate={handleDemoExpiryDate}
                                  strings={defaultDatePickerStrings}
                                  isRequired={false}
                                  placeholder="Select date"
                                  minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                                  formatDate={(date) => {
                                    if (!date) return "";
                                    const day = String(date.getDate()).padStart(2, '0');
                                    const month = date.toLocaleString('en', { month: 'short' }).toLowerCase();
                                    const year = date.getFullYear();
                                    return `${day}-${month}-${year}`;
                                  }}
                                  calendarProps={{
                                    calendarDayProps: {
                                      styles: {
                                        dayIsToday: {
                                          backgroundColor: "transparent !important",
                                          borderRadius: "0 !important",
                                          color: "inherit !important",
                                          fontWeight: "normal !important",
                                        },
                                      },
                                    },
                                  }}
                                />
                          </div>
                            {demoExpiryDate && (
                              <IconButton
                                iconProps={{ iconName: "Cancel" }}
                                onClick={() => handleDemoExpiryDate(null)}
                                title="Clear date"
                                ariaLabel="Clear date"
                              />
                            )}
                          </>
                        )}
                        {demoExpiryType === "uploads" && (
                          <TextField
                            type="number"
                            min={1}
                            value={maxStudyUploads != null ? String(maxStudyUploads) : ""}
                            onChange={handleMaxStudyUploads}
                            placeholder="Maximum uploads"
                            style={{ width: 200 }}
                          />
                        )}
                      </div>
                      {demoExpiryType === "uploads" && demoStudyCount != null && maxStudyUploads != null && maxStudyUploads > 0 && (
                        <div style={{ marginTop: 8, fontSize: "12px", color: "#666" }}>
                          Studies Consumed: {demoStudyCount} / {maxStudyUploads}
                        </div>
                      )}
                      {demoError && (
                        <div style={{ marginTop: 8 }}>
                          <span style={{ fontSize: "12px", fontWeight: "700", color: "#ff0000" }}>
                            {demoError}
                          </span>
                        </div>
                      )}
                    </>
                  )}
                  <p style={{ fontSize: "12px", color: "#666" }}>
                    *Demo Status will deactivate automatically once the selected expiry criteria is reached.
                  </p>
                </fieldset>
              )}
          </div>
        </div>
      )}

      {props.action === ACTIONS.VIEW &&
        (props.roles[0] === USERTYPES.FIRMADMIN || !props.ownFirm) && (
          <div className="tab-section">
            <section className="sectionA" style={{ marginBottom: "1rem" }}>
              <p
                style={{
                  fontSize: "22px",
                  fontWeight: "600",
                  padding: "0px 0px",
                }}
              >
                {enterprise
                  ? t("hospital.hospital-details")
                  : props.firmType === 1
                    ? t("hospital.provider-details")
                    : props.ownFirm || props.roles[0] === USERTYPES.ADMIN
                      ? t("hospital.firm-details")
                      : t("hospital.client-details")}
              </p>
            </section>
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <div className="form-heading">{t("hospital.name")}</div>
                  <div className="form-mt-10">{props.values.name}</div>
                </div>
                {props.roles[0] != USERTYPES.SUPERVISOR && (
                  <>
                    <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                      <div className="form-heading">
                        {t("hospital.address")}
                      </div>
                      <div className="form-mt-10">{props.values.address}</div>
                    </div>
                  </>
                )}
              </div>
              {props.roles[0] != USERTYPES.SUPERVISOR && (
                <>
                  <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                    <div className="ms-Grid-col ms-sm10 ms-md6 ms-lg2 ms-xl4">
                      <div className="form-heading">
                        {t("hospital.country")}
                      </div>
                      <div className="form-mt-10">{props.values.country}</div>
                    </div>
                    <div className="ms-Grid-col ms-sm10 ms-md6 ms-lg2 ms-xl4">
                      <div className="form-heading">{t("hospital.state")}</div>
                      <div className="form-mt-10">{props.values.state}</div>
                    </div>
                    <div className="ms-Grid-col ms-sm10 ms-md6 ms-lg2 ms-xl4">
                      <div className="form-heading">{t("hospital.city")}</div>
                      <div className="form-mt-10">{props.values.city}</div>
                    </div>
                  </div>
                  {/* (removed): "Max Priority Count" was shown here on the client
                      VIEW screen (Client Details). It already appears on the Configure
                      Settings page, so it is removed from the view to avoid duplication.
                  {props.roles[0] === USERTYPES.FIRMADMIN && !props.ownFirm && (
                    <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                      <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                        <div className="form-heading">
                          {t("hospital.max-priority-count")}
                        </div>
                        <div className="form-mt-10">
                          {props.values.priorityCount}
                        </div>
                      </div>
                    </div>
                  )}
                  */}

                  <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                      <div className="form-heading">
                        {t("hospital.triage-xray")}
                      </div>
                      <div className="form-mt-10">
                        {props.values.triageXRAYStudies ? "Yes" : "No"}
                      </div>
                    </div>
                  </div>
                </>
              )}
              {!props.values.isClientWarning &&
                props.roles[0] != USERTYPES.SUPERVISOR && (
                  <>
                    <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                      <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                        <div className="form-heading">
                          {t("hospital.status")}
                        </div>
                        <div className="form-mt-10">
                          {props.values.active ? "Active" : "Inactive"}
                        </div>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                        <div className="form-heading">{t("hospital.type")}</div>
                        <div className="form-mt-10">
                          {props.values.firmType}
                        </div>
                      </div>
                    </div>
                    <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                      <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12">
                        <div className="form-heading">{t("hospital.code")}</div>
                        <div className="form-mt-10">{props.values.code}</div>
                      </div>
                    </div>
                  </>
                )}

              {(props.roles[0] === USERTYPES.ADMIN ||
                props.roles[0] === USERTYPES.FIRMADMIN) && (
                <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                  {props.roles[0] === USERTYPES.ADMIN && (
                    <>
                      <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                        <div className="form-heading">
                          {t("hospital.study-list-mode")}
                        </div>
                        <div className="form-mt-10">
                          {props.values.cxrVersionStudyList
                            ? "Analyzer"
                            : "Detect"}
                        </div>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                        <div className="form-heading">
                          {t("hospital.viewer-mode")}
                        </div>
                        <div className="form-mt-10">
                          {props.values.cxrVersionViewer
                            ? "Analyzer"
                            : "Detect"}
                        </div>
                      </div>
                    </>
                  )}

                  {props.roles[0] === USERTYPES.FIRMADMIN && props.ownFirm && (
                    <>
                      <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                        <div className="form-heading">
                          {t("hospital.study-list-mode")}
                        </div>
                        <div className="form-mt-10">
                          {props.values.cxrVersionStudyList
                            ? "Analyzer"
                            : "Detect"}
                        </div>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                        <div className="form-heading">
                          {t("hospital.viewer-mode")}
                        </div>
                        <div className="form-mt-10">
                          {props.values.cxrVersionViewer
                            ? "Analyzer"
                            : "Detect"}
                        </div>
                      </div>
                    </>
                  )}

                  <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                    <div className="form-heading">
                      {t("hospital.subtleFindings")}
                    </div>
                    <div className="form-mt-10">
                      {props.values.subtleFindings ? "Yes" : "No"}
                    </div>
                  </div>
                </div>
              )}
              <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                {(props.values.cxrVersionViewer ||
                  props.values.cxrVersionStudyList) && (
                  <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                    <div className="form-heading">
                      {t("hospital.bone-enabled")}
                    </div>
                    <div className="form-mt-10">
                      {props.values.boneEnabled ? "Yes" : "No"}
                    </div>
                  </div>
                )}
                <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.showFindings")}
                  </div>
                  <div className="form-mt-10">
                    {props.values.showFindings ? "Yes" : "No"}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.showProbability")}
                  </div>
                  <div className="form-mt-10">
                    {props.values.showProbability ? "Yes" : "No"}
                  </div>
                </div>
                {isParentFirm && (
                  <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                    <div className="form-heading">
                      {t("hospital.cxr-triage-min-age")}
                    </div>
                    <div className="form-mt-10">
                      {props.values.cxrTriageMinAge != null
                        ? t("hospital.cxr-triage-min-age-years", {
                            age: Math.max(props.values.cxrTriageMinAge, cxrTriageModeMinAge),
                          })
                        : t("hospital.cxr-triage-min-age-not-configured", {
                            min: cxrTriageModeMinAge,
                          })}
                    </div>
                  </div>
                )}
              </div>
              <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.showAboveThresholdScore")}
                  </div>
                  <div className="form-mt-10">
                    {props.values.showAboveThresholdScore ? "Yes" : "No"}
                  </div>
                </div>

                <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enableGenkiStudyInference")}
                  </div>
                  <div className="form-mt-10">
                    {props.values.enableGenkiStudyInference ? "Yes" : "No"}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-secondary-capture")}
                  </div>
                  <div className="form-mt-10">
                    {props.values.enableSecondaryCapture ? "Yes" : "No"}
                  </div>
                </div>
              </div>
              <div className="ms-Grid-row" style={{ marginTop: "18px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-quality-model")}
                  </div>
                  <div className="form-mt-10">
                    {props.values.enableQualityModel ? "Yes" : "No"}
                  </div>
                </div>
              </div>
              <div className="ms-Grid-row" style={{ marginTop: "18px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.compress-study-download")}
                  </div>
                  <div className="form-mt-10">
                    {props.values.compressStudyDownload ? "Yes" : "No"}
                  </div>
                </div>
              </div>
              {props.roles[0] === USERTYPES.ADMIN && (
                <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                    <div className="form-heading">
                      {t("hospital.mark-as-external-firm")}
                    </div>
                    <div className="form-mt-10">
                      {props.values.externalFirm
                        ? t("hospital.yes")
                        : t("hospital.no")}
                    </div>
                  </div>
                </div>
              )}
              { ((props.roles[0] === USERTYPES.FIRMADMIN && !props.ownFirm) || props.roles[0] === USERTYPES.ADMIN) && (
                <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                    <div className="form-heading">
                      {t("hospital.demo-firm")}
                    </div>
                    <div className="form-mt-10">
                      {props.values.demoFirm ? t("hospital.yes") : t("hospital.no")}
                    </div>
                  </div>
                  {props.values.demoFirm && props.values.demoExpiryType && (
                    <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                      <div className="form-heading">
                        {props.values.demoExpiryType === "date"
                          ? t("hospital.demo-expiry-date")
                          : t("hospital.max-study-uploads")}
                      </div>
                      <div className="form-mt-10">
                      {props.values.demoExpiryType === "date"
                        ? (props.values.demoExpiryDate instanceof Date && !isNaN(props.values.demoExpiryDate)
                          ? `${String(props.values.demoExpiryDate.getDate()).padStart(2, '0')}-${props.values.demoExpiryDate.toLocaleString('en', { month: 'short' }).toLowerCase()}-${props.values.demoExpiryDate.getFullYear()}`
                          : "—")
                        : (props.values.maxStudyUploads != null ? props.values.maxStudyUploads : "—")}
                    </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
    </>
  );
};

export default HospitalDetailsSection;
